import { defineStore } from 'pinia';
import axios from 'axios';

export const useResourceStore = defineStore('resourceStore', {
    state: () => ({
        loading              : false,
        results              : [],
        pagination           : {},
        mobileFilterMenuOpen : false,
    }),
    actions: {
        async getResources(mainCategory, payload) {

            if (mainCategory.slug !== 'all') {
                payload.mainCategory = mainCategory.slug;
            }

            this.startLoading();

            try {
                const response = await this.fetchResources(payload);
                this.updateResults(response.data.data);
                this.updatePagination(response.data.meta.pagination);
            } catch (error) {
                console.error('Something went wrong', error);
            } finally {
                this.stopLoading();
            }
        },
        async fetchResources(payload) {
            return axios({
                method: 'GET',
                url:  (window.currentSite == 'GB' ? '/gb-ie' : '') + '/resources.json',
                params: payload
            });
        },
        updateResults(data) {
            this.results = data;
        },
        updatePagination(pagination) {
            this.pagination = pagination;
        },
        startLoading() {
            this.loading = true;
        },
        stopLoading() {
            this.loading = false;
        },
        toggleMobileFilterMenu() {
            this.mobileFilterMenuOpen = !this.mobileFilterMenuOpen;
        },
    }
});
